export interface SnackbarSliceType {
    errorCode: number;
    position?: 'top' | 'bottom';
    errorMessage: string;
}

export const SnackbarMessageInitState: SnackbarSliceType = {
    errorCode: 0,
    position: 'bottom',
    errorMessage: '',
};
